import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  paymentStatus: string;
  cicodOrderId: string;


  subscription: Subscription
  constructor(private route: ActivatedRoute) { }

  getPaymentDetails(){
    this.subscription = this.route.queryParamMap.subscribe(param =>{
      this.paymentStatus = param.get("paymentStatus");
      // this.cicodOrderId = param.get("cicodOrderId");
    });
  }

  ngOnInit() {
    this.getPaymentDetails()
  }

}
